export default __webpack_public_path__ + "static/media/feather_external-link.0669bd5e.svg";